import { mapGetters } from 'vuex';

import PzButton from '@/components/PzButton.vue';
import EmptyList from '@/views/Events/components/EmptyList.vue';
//import EventListInPanel from '@/views/Events/components/EventListInPanel.vue';

export default {
  name: 'MainModeHistoryPaperList',

  components: {
    PzButton,
    EmptyList,
    //EventListInPanel,
  },

  props: {
    goThroughMock: {
      type: Function,
      default: () => null,
    },
  },

  data() {
    return {};
  },

  computed: {
    ...mapGetters('Events', {
      mg_DoneList: 'DoneList',
      mg_selectedDoneList: 'selectedDoneList',
    }),
  },
};
